import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=1dcc7b72"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dcc7b72')) {
      api.createRecord('1dcc7b72', component.options)
    } else {
      api.reload('1dcc7b72', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=1dcc7b72", function () {
      api.rerender('1dcc7b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/province/edit.vue"
export default component.exports